var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-provider',{staticClass:"w-100",attrs:{"name":_vm.title,"rules":_vm.schema.rules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('v-text-field',{attrs:{"type":"number","min":0,"error-messages":errors,"placeholder":_vm.schema.placeholder},model:{value:(_vm.localItem),callback:function ($$v) {_vm.localItem=$$v},expression:"localItem"}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }